/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { SelfServiceConfigCheckinRequest } from '../../models/self-service-config-checkin-request';
import { SelfServiceConfigCheckinResponse } from '../../models/self-service-config-checkin-response';

export interface PutSelfServiceConfigCheckin$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
      body: SelfServiceConfigCheckinRequest
}

export function putSelfServiceConfigCheckin(http: HttpClient, rootUrl: string, params: PutSelfServiceConfigCheckin$Params, context?: HttpContext): Observable<StrictHttpResponse<SelfServiceConfigCheckinResponse>> {
  const rb = new RequestBuilder(rootUrl, putSelfServiceConfigCheckin.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelfServiceConfigCheckinResponse>;
    })
  );
}

putSelfServiceConfigCheckin.PATH = '/administration/organization-sites/{organizationSiteKey}/self-checkin';
